/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/angularjs/angular-js.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { Component, ElementRef } from "@angular/core";
import * as ng from "angular";
import visionics from "vics/visionics/js/main";
import * as i0 from "@angular/core";
export class AngularJsComponent {
    /**
     * @param {?} elementRef
     */
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.app = ng.bootstrap(this.elementRef.nativeElement, [
            visionics.name,
            "third_party",
        ], {
            strictDi: false,
        });
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (!this.app) {
            // Angular was never initialized
            return;
        }
        this.app.get("$rootScope").$destroy();
    }
}
AngularJsComponent.decorators = [
    { type: Component, args: [{
                selector: "angular-js",
                template: "<div ng-view></div>",
            },] },
];
/** @nocollapse */
AngularJsComponent.ctorParameters = () => [
    { type: ElementRef }
];
/** @nocollapse */ AngularJsComponent.ɵfac = function AngularJsComponent_Factory(t) { return new (t || AngularJsComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
/** @nocollapse */ AngularJsComponent.ɵcmp = i0.ɵɵdefineComponent({ type: AngularJsComponent, selectors: [["angular-js"]], decls: 1, vars: 0, consts: [["ng-view", ""]], template: function AngularJsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0);
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(AngularJsComponent, [{
        type: Component,
        args: [{
                selector: "angular-js",
                template: "<div ng-view></div>",
            }]
    }], function () { return [{ type: i0.ElementRef }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    AngularJsComponent.prototype.app;
    /**
     * @type {?}
     * @private
     */
    AngularJsComponent.prototype.elementRef;
}
//# sourceMappingURL=data:application/json;base64,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